import { render, staticRenderFns } from "./storage-detail.vue?vue&type=template&id=57f7c546"
import script from "./storage-detail.vue?vue&type=script&lang=js"
export * from "./storage-detail.vue?vue&type=script&lang=js"
import style0 from "./storage-detail.vue?vue&type=style&index=0&id=57f7c546&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports